"use client"

import { useEffect } from "react"

/**
 * Timezone cookie round-trip (US-011), ported from retail. The client writes its
 * resolved IANA timezone to a `timezone` cookie; on the NEXT request the server
 * http-client reads it back (`cookieStore.get("timezone")` in
 * packages/api/src/http-client.ts) and forwards it as `x-timezone` so the backend
 * localizes times to the diner. The cookie name MUST stay in sync with the
 * http-client's `cookies().get("timezone")`.
 */
export function TimezoneInitializer() {
  useEffect(() => {
    const tz = Intl.DateTimeFormat().resolvedOptions().timeZone
    if (!tz) return

    // Non-httpOnly (must be readable/writable from the client), lax, 1-year TTL.
    document.cookie = `timezone=${encodeURIComponent(tz)}; path=/; max-age=31536000; samesite=lax`
  }, [])

  return null
}
